var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.095 1.096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 8.6a.65.65 0 0 1-.277-.062l-7.75-3.65a.65.65 0 0 1 0-1.176L8.128.061a.65.65 0 0 1 .554 0l7.755 3.65a.65.65 0 0 1 0 1.176l-7.755 3.65A.65.65 0 0 1 8.4 8.6zM2.176 4.3 8.4 7.23l6.233-2.93L8.4 1.368z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 12.7a.65.65 0 0 1-.277-.062L.373 8.993a.65.65 0 0 1 .553-1.176L8.4 11.335l7.478-3.519a.65.65 0 1 1 .553 1.176l-7.75 3.65a.65.65 0 0 1-.281.058z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 16.809a.65.65 0 0 1-.277-.062L.373 13.1a.65.65 0 1 1 .553-1.176L8.4 15.441l7.478-3.519a.65.65 0 1 1 .553 1.176l-7.75 3.649a.65.65 0 0 1-.281.062z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.c6a880bed05f0fb4086a2dfc4bbfa56e.svg";
export { ForwardRef as ReactComponent };